/**
 * Timeline selection event type.
 */
export enum TimelineSelectionEventSource {
  /**
   * Keyframe selection is performed.
   */
  Keyframes = 'keyframes',
}
